import { useState } from "react";
import { handleException } from "../../../app/util/util";
const useSearchVideo = (videoName) => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [videosFound, setVideosFound] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [showVideosFound, setShowVideosFoun] = useState(false);
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
        };
    };
    const searchVideos = async (productId, ppSubjectAreaTagId) => {
        if (videoName.length) {
            videoName = videoName.replace(/[\s\t]+/g, ' ').trim();
            setIsSearching(true);
            let reqData = {
                userVO: {
                    userId: userVO.userId,
                    userRole: userVO.userRole,
                    schoolId: userVO.schoolId,
                    userRoleId: userVO.userRoleId,
                    userActivityVO: {
                        lastReadBookId: "",
                        themisProductId: "",
                        lastReadPageNum: "",
                        lastReadChapterId: "",
                        lastReadSectionId: "",
                        themisSubjectAreaId: "",
                        lastViewedOutlineId: "",
                        lastReadSubSectionId: "",
                        schoolId: userVO.schoolId,
                        pageNavigatingTo: "EReader",
                        lastSearchKeyword: videoName,
                        lastActivityCode: "BOOKSHELF",
                        pageNavigatingFrom: "Bookshelf",
                        ppSubjectAreaTagId: ppSubjectAreaTagId,
                    },
                    sessionVO: getSessionVO(),
                },
                ppSubjectAreaTagId: ppSubjectAreaTagId,
                ppProductVO: { searchKeyword: videoName, productId: "", },
            };
            const requestOptions = {
                method: "POST",
                body: JSON.stringify(reqData),
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            };
            const data = await (await fetch(`${localStorage.getItem('ENV')}/managePP/searchPPVideos`, requestOptions)).json();
            if (data.status === "true" && data.ppTopicVOList) {
                data.ppTopicVOList = Array.isArray(data.ppTopicVOList) ? data.ppTopicVOList : [data.ppTopicVOList];
                data.ppTopicVOList.forEach((video, i) => {
                    if (video.ppSubTopicVOList) {
                        data.ppTopicVOList[i].ppSubTopicVOList = Array.isArray(video.ppSubTopicVOList) ? video.ppSubTopicVOList : [video.ppSubTopicVOList];
                    }
                });
                setVideosFound(data.ppTopicVOList);
                setShowVideosFoun(true);
                setShowMessage(false);
            } else if (data.wkErrorCode) {
                handleException(data);
            }
            setIsSearching(false);
        } else {
            setVideosFound([]);
            setShowMessage(false);
            setShowVideosFoun(false);
        }
    };
    const handleResetVideoState = () => {
        setVideosFound([]);
        setShowMessage(false);
        setShowVideosFoun(false);
    };
    return {
        videosFound,
        isSearching,
        showMessage,
        showVideosFound,
        searchVideos,
        handleResetVideoState,
    };
};
export default useSearchVideo;
